<template>
  <div>
    <h1>
      <v-icon color="black">mdi-video-box</v-icon>
      {{ $t("chapter.video.videoSettings") }}
    </h1>
    <v-expansion-panels :value="0">
      <v-expansion-panel>
        <v-expansion-panel-header>{{
          $t("chapter.video.videoContents")
        }}</v-expansion-panel-header>
        <v-expansion-panel-content v-if="editor">
          <div >
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card elevation="0" color="transparent mb-3">
                  <v-card-text>
                    <video v-if="videoUrl" class="video-preview" :key="videoUrl">
                      <source :src="videoUrl" />
                    </video>
                    <v-fade-transition>
                      <v-overlay v-show="hover && !loading || !videoUrl || videoUrl == ''" absolute :color="videoUrl? 'black' : 'transparent'">
                        <MediaObjectUpload
                          v-model="uploadUrl"
                          :addText="$t('chapter.video.chooseVideo')"
                          :changeText="$t('chapter.video.chooseVideo')"
                          @error="setErrorMessage"
                          @loading="loading = $event"
                          :errorTooLargeMessage="
                            $t('chapter.video.videoTooLarge', {
                              maxVideoSize: MAX_VIDEO_SIZE_MB,
                            })
                          "
                          :maxSizeBytes="MAX_VIDEO_SIZE_BYTES"
                          :formats="VIDEO_FORMATS"
                        />
                      </v-overlay>
                    </v-fade-transition>
                  </v-card-text>
                </v-card>
              </template>
            </v-hover>
          </div>
          <span class="error-text">{{ errorMessage }}</span>
          <div class="text-left my-3" v-if="loading">
            {{ $t("forms.uploading") }}
            <v-progress-linear
              indeterminate
              color="primaryAction darken-2"
            ></v-progress-linear>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<script>
import MediaObjectUpload from "@/components/MediaObjectUpload";
import { VIDEO_FORMATS } from "@/const";
const EXTENSION_NAME = "video";
const MAX_VIDEO_SIZE_MB = 250;
const MAX_VIDEO_SIZE_BYTES = MAX_VIDEO_SIZE_MB * 1024 * 1024;
export default {
  props: {
    editor: Object,
  },
  components: {
    MediaObjectUpload,
  },
  data() {
    return {
      loading: false,
      uploadUrl: null,
      errorMessage: "",
    };
  },
  methods: {
    setErrorMessage(message) {
      this.errorMessage = message;
    },
  },
  computed: {
    VIDEO_FORMATS() { return VIDEO_FORMATS },
    MAX_VIDEO_SIZE_MB() { return MAX_VIDEO_SIZE_MB },
    MAX_VIDEO_SIZE_BYTES() { return MAX_VIDEO_SIZE_BYTES },
    isActive() {
      return this.editor.isActive(EXTENSION_NAME);
    },
    videoUrl() {
      return this.editor.getAttributes(EXTENSION_NAME).src;
    },
  },
  watch: {
    uploadUrl(newValue) {
      this.editor.chain().focus().setVideoSrc(newValue).run();
    },
    videoUrl(newValue) {
      this.uploadUrl = newValue;
    },
  },
};
</script>
<style lang="scss" scoped>
.video-preview {
  height: auto;
  max-width: 100%;
  width: auto;
}
</style>
